import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckSiteIds } from '@api/hitoryCheck';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { ICMMavenirVendor } from '@interfaces/cmModule/cmModule';
import { TCMSitesIdsDTO } from '@interfaces/cmModule/dto/cmModuleDTO';
import { IModalSelectOption } from '@components/common/ModalSelect/ModalSelect.types';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_SITE_IDS } from '@constants/queryKeys';

type TUseQueryHistoryCheckSiteIds = ICMMavenirVendor & TCMSitesIdsDTO

interface IUseQueryHistoryCheckSiteIdsReturnValue {
	siteIdsOptions?: IModalSelectOption[];
	isFetchingSiteIdsOptions: boolean;
	isLoadingSiteIdsOptions: boolean;
}

export const useQueryHistoryCheckSiteIds = (
	params: TUseQueryHistoryCheckSiteIds,
): IUseQueryHistoryCheckSiteIdsReturnValue => {
	const {
		vendor,
		technology,
		nodeType,
		isMavenirVendor,
	} = params;

	const {
		data: siteIdsOptions,
		isFetching: isFetchingSiteIdsOptions,
		isLoading: isLoadingSiteIdsOptions,
	} = useQuery<string[], IModalSelectOption[]>({
		queryKey: [
			HISTORY_CHECK_SITE_IDS,
			params,
		],
		queryFn: extractQueryParams(getHistoryCheckSiteIds),
		select: (options: Array<string>) => fieldsOptionsFormatted(options),
		enabled: [!!technology, !!vendor, !!nodeType, !isMavenirVendor],
		...refetchOptions,
	});

	return {
		siteIdsOptions,
		isFetchingSiteIdsOptions,
		isLoadingSiteIdsOptions: (isLoadingSiteIdsOptions && !!siteIdsOptions)
			|| isFetchingSiteIdsOptions,
	};
};
